module.exports = __webpack_public_path__ + "static/Joy.c6f7b4c9.png";